import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import DefaultProfilePicture from "../../common/defaultProfilePicture/DefaultProfilePicture";

const SuccessScan = ({
  isOpen,
  closeModal,
  eventId,
  setIsOpen,
  setScannedUser,
  scannedUser,
  setTriggerNotes,
}) => {
  const navigate = useNavigate();

  const formatDate = (date) => {
    const utcDate = new Date(date);

    const options = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    };
    const formatter = new Intl.DateTimeFormat("en-IN", options);
    const dateString = formatter.format(utcDate);
    return dateString;
  };

  return (
    <div className="">
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-70" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto w-full h-full">
            <div className="flex h-full p-0 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className=" transform overflow-hidden bg-white align-middle shadow-xl transition-all  w-full h-full flex justify-center items-center border flex-col"
                  // style={{ ...style }}
                >
                  <div>
                    {/* <div className="absolute top-0 left-0 z-50 p-4 text-[20px] font-medium">
                      Title
                    </div> */}
                    <div
                      className="modal-close absolute top-0 right-0 cursor-pointer z-50 p-4"
                      onClick={() => {
                        closeModal();
                      }}
                    >
                      <svg
                        className="fill-current text-black"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 18 18"
                      >
                        <path d="M0 0h18v18H0z" fill="none" />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M10.293 9l4.646-4.646a1 1 0 10-1.414-1.414L9 7.586 4.354 2.94a1 1 0 10-1.414 1.414L7.586 9l-4.646 4.646a1 1 0 001.414 1.414L9 10.414l4.646 4.646a1 1 0 001.414-1.414L10.414 9z"
                          fill="#374151"
                        />
                      </svg>
                    </div>
                  </div>

                  {/* <div className="flex justify-center flex-col p-5">
                    {scannedUser?.profilePicture ? (
                      <img
                        src={scannedUser?.profilePicture}
                        alt=""
                        className="h-[110px] w-[110px] border m-auto rounded-full"
                      />
                    ) : (
                      <div className="cursor-pointer m-auto">
                        <DefaultProfilePicture
                          firstName={scannedUser?.firstName}
                          lastName={scannedUser?.lastName}
                          style={{
                            width: "110px",
                            height: "110px",
                            borderRadius: "300px",
                            fontSize: "33px",
                          }}
                        />
                      </div>
                    )}
                    <div className="mt-5 flex flex-col gap-1">
                      <p className="text-[25px] font-medium">
                        {scannedUser?.firstName} {scannedUser?.lastName}
                      </p>
                      <p className="text-[20px]">{scannedUser?.jobTitle}</p>

                      <p className="text-[20px]">{scannedUser?.organization}</p>
                    </div>

                    <div className="mt-2 text-left">
                      <p className="line-clamp-2">
                        I'm very communicative, detail-oriented, and versatile.
                        I like to think of myself as a team player. While I
                        don't mind taking on solo projects, I prefer to work
                        with others. I like to think that I'm persistent and
                        persuasive.{scannedUser?.bio}
                      </p>
                    </div>
                  </div> */}

                  <div className="w-[160px] relative flex justify-center items-center mt-0">
                    {scannedUser?.isLeadSuccess ? (
                      <>
                        <img
                          src="/svgs/Animate.svg"
                          alt="check"
                          className=" "
                        />
                        <img
                          src="/svgs/Checkcircle.svg"
                          alt="check"
                          className=" rounded-full w-[60px] absolute z-30 bg-white"
                        />
                      </>
                    ) : (
                      <>
                        <img
                          src="/svgs/FailedAnimate.svg"
                          alt="check"
                          className=" "
                        />
                        <img
                          src="/svgs/Cancelled.svg"
                          alt="check"
                          className=" rounded-full w-[60px] absolute z-30 bg-white "
                        />
                      </>
                    )}
                  </div>
                  <p
                    className={`leading-3 text-[25px] font-medium text-${
                      scannedUser?.isLeadSuccess ? "[#2ECC71]" : "red-500"
                    }`}
                  >
                    {scannedUser?.isLeadSuccess ? "Success!" : "Failed"}
                  </p>
                  <p className="text-[16px] text-gray-400  font-medium pt-4">
                    {scannedUser?.isLeadSuccess
                      ? "Badge Scanned Successfully"
                      : "Lead already exists!"}
                  </p>

                  <div className="mx-5 w-full flex justify-center">
                    <div className="border rounded-[10px] w-full mx-4 flex flex-col shadow-[0_0px_4px_1px_rgba(0,0,0,0.1)] px-3 py-4 text-[20px] mt-6">
                      {/* {scannedUser?.isLeadSuccess ? (
                      <p>
                        <span className="font-medium whitespace-normal break-all">
                          {scannedUser?.firstName} {scannedUser?.lastName}
                        </span>{" "}
                        added to leads.
                      </p>
                    ) : (
                      <p>
                        <span className="font-medium whitespace-normal break-all">
                          {scannedUser?.firstName} {scannedUser?.lastName}
                        </span>{" "}
                        is already part of your leads.
                      </p>
                    )} */}
                      <div className="flex gap-3 items-center w-full">
                        <div className=" min-w-[66px] max-w-[66px]">
                          {scannedUser?.attendee?.scannedUser
                            ?.profilePicture ? (
                            <img
                              src={
                                scannedUser?.attendee?.scannedUser
                                  ?.profilePicture
                              }
                              className="rounded-full w-[66px] h-[66px] object-cover"
                              alt="ProfilePic"
                            />
                          ) : (
                            <div className="">
                              <DefaultProfilePicture
                                firstName={
                                  scannedUser?.attendee?.scannedUser.firstName
                                }
                                lastName={
                                  scannedUser?.attendee?.scannedUser.lastName
                                }
                                style={{
                                  width: "66px",
                                  height: "66px",
                                  borderRadius: "300px",
                                  fontSize: "24px",
                                }}
                              />
                            </div>
                          )}
                        </div>
                        <div className="flex flex-col gap-0.5 text-left w-full">
                          <div className="sm:text-[14px] text-[17x] font-[500] md:font-semibold line-clamp-1 pt-1">
                            {scannedUser?.attendee?.scannedUser.firstName}{" "}
                            {scannedUser?.attendee?.scannedUser.lastName}{" "}
                          </div>
                          <div className="text-[16px] font-normal text-gray-500 py-[0px] line-clamp-1">
                            {scannedUser?.attendee?.scannedUser.jobTitle}
                          </div>
                          <div className="text-[16px] font-normal text-gray-500 py-[0px] line-clamp-1">
                            {scannedUser?.attendee?.scannedUser?.organization}
                          </div>
                        </div>
                      </div>

                      <div className="mt-3 flex flex-col gap-2">
                        <div className="flex items-center gap-2 text-[16px] font-normal text-gray-500 py-[0px] line-clamp-1">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            width="22px"
                            height="22px"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                d="M4 7.00005L10.2 11.65C11.2667 12.45 12.7333 12.45 13.8 11.65L20 7"
                                stroke="#7d7d7d"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>{" "}
                              <rect
                                x="3"
                                y="5"
                                width="18"
                                height="14"
                                rx="2"
                                stroke="#7d7d7d"
                                stroke-width="2"
                                stroke-linecap="round"
                              ></rect>{" "}
                            </g>
                          </svg>
                          <p className="pl-0.5">
                            {scannedUser?.attendee?.scannedUser?.email}
                          </p>
                        </div>

                        <div className="flex items-center gap-2 text-[16px] font-normal text-gray-500 py-[0px] line-clamp-1">
                          <svg
                            fill="#7d7d7d"
                            width="24px"
                            height="24px"
                            viewBox="-8.5 0 32 32"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <title>mobile</title>{" "}
                              <path d="M11.84 27.84h-8.32c-1.96 0-3.52-1.6-3.52-3.52v-16.64c0-1.96 1.6-3.52 3.52-3.52h8.32c1.96 0 3.52 1.6 3.52 3.52v16.64c0 1.92-1.56 3.52-3.52 3.52zM3.52 5.84c-1 0-1.84 0.84-1.84 1.84v16.64c0 1 0.84 1.84 1.84 1.84h8.32c1 0 1.84-0.84 1.84-1.84v-16.64c0-1-0.84-1.84-1.84-1.84h-8.32zM7.68 25.12c-1.52 0-2.76-1.24-2.76-2.76s1.24-2.76 2.76-2.76 2.76 1.24 2.76 2.76c0 1.52-1.24 2.76-2.76 2.76zM7.68 21.24c-0.6 0-1.080 0.48-1.080 1.080s0.48 1.080 1.080 1.080 1.080-0.48 1.080-1.080c0.040-0.56-0.48-1.080-1.080-1.080z"></path>{" "}
                            </g>
                          </svg>
                          <p>
                            {scannedUser?.attendee?.scannedUser?.mobile ||
                              "N/A"}
                          </p>
                        </div>
                      </div>
                      {/* <span
                      className="flex items-center cursor-pointer text-white text-[16px] font-[500] h-[38px] w-full justify-center rounded-[6px] bg-primary md:w-[100%] mt-3"
                      onClick={() => {
                        setTriggerNotes(true);
                        setScannedUser(scannedUser);
                      }}
                    >
                      Add Notes and Rating
                    </span>
                    <div className="mt-3 w-[100%] gap-3">
                      <button
                        className="h-[38px] rounded-[4px] text-[#1C1C1E] font-[500] text-[16px] px-2 w-full border bg-gray-100"
                        onClick={() => {
                          navigate(`/attendee/${eventId}?tab=leads&view=leads`);
                        }}
                      >
                        Check all leads
                      </button>

                      <button
                        className="bg-primary border text-white font-[500]  rounded-[4px] h-[38px] text-[16px] px-2 w-full mt-3"
                        onClick={() => {
                          setIsOpen(false);
                          setScannedUser({});
                        }}
                      >
                        Scan another badge
                      </button>
                    </div> */}
                    </div>
                  </div>

                  <div className="px-4 w-full">
                    <span
                      className="flex items-center cursor-pointer text-white text-[16px] font-[500] h-[40px] w-full justify-center rounded-[8px] bg-primary md:w-[100%] mt-5"
                      onClick={() => {
                        setTriggerNotes(true);
                        setScannedUser(scannedUser);
                        closeModal("false");
                      }}
                    >
                      Add Notes and Rating
                    </span>
                    <span
                      className="flex items-center cursor-pointer text-primary text-[16px] font-[500] h-[40px] w-full justify-center rounded-[8px] bg-white md:w-[100%] mt-5 border"
                      onClick={() => {
                        setIsOpen(false);
                        setScannedUser({});
                      }}
                    >
                      Scan Next
                    </span>
                    {/* <button
                      className="bg-primary border text-white font-[500]  rounded-[4px] h-[38px] text-[16px] px-2 w-full mt-3"
                      onClick={() => {
                        setIsOpen(false);
                        setScannedUser({});
                      }}
                    >
                      Scan another badge
                    </button> */}
                  </div>

                  <div className="flex justify-between items-center w-[90%] mt-5">
                    <div className="border rounded-[10px] p-2 text-[15px] w-[48%] shadow-[0_0px_4px_1px_rgba(0,0,0,0.1)]">
                      <p className="text-[13px] text-gray-400">Scan Time</p>
                      <p className="font-medium text-gray-800">
                        {formatDate(scannedUser?.meetingTime)}
                      </p>
                    </div>
                    <div className="border rounded-[10px] p-2 text-[15px] w-[48%] shadow-[0_0px_4px_1px_rgba(0,0,0,0.1)]">
                      <p className="text-[13px] text-gray-400">Status</p>
                      <p className="font-medium text-green-500">Captured</p>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default SuccessScan;
